import React from 'react';
import { View } from 'react-native';

import { NutritionFactsProps } from './nutrition-facts/nutrition-facts';
import { NutritionalBottomSheet } from './nutritional-bottom-sheet';

type NutritionalInformationProps = {
  nutritionFacts: NutritionFactsProps;
  onClose: () => void;
  isVisible: boolean;
  showNutritionixLink?: boolean;
};

export const NutritionalInformation = ({
  nutritionFacts,
  onClose,
  isVisible,
  showNutritionixLink = true,
}: NutritionalInformationProps) => {
  return (
    <View>
      <NutritionalBottomSheet
        onClose={onClose}
        isVisible={isVisible}
        headerTitle="Nutritional Information"
        nutritionFacts={nutritionFacts}
        showNutritionixLink={showNutritionixLink}
      />
    </View>
  );
};
